import { transition } from '@angular/animations';
import { environment } from '@teem/environments/environment';

const baseUrl = environment.apiHost;
const apiUrl = environment.apiUrl;
const webRoute = environment.baseUrl;

export const general: any = {
	plans: `${baseUrl}/plans`,
	verify_promocode: `${baseUrl}/verify-freelance-sa`,
	verify_cr_freelance: `${baseUrl}/verify-cr-freelance`,
	change_plan: `${baseUrl}/change-plan`,
	trial_plan: `${baseUrl}/trial-plan`,
	add_card: `${baseUrl}/add-card`,
	currencies: `${baseUrl}/currencies`,
	send_notify: `${baseUrl}/send-notify`
}

export const order: any = {
	endPoint: `${baseUrl}/orders`,
	stats: `${baseUrl}/orders/stats`,
	action: `${baseUrl}/orders/action`,
	getStatuses: (uuid) => `${baseUrl}/orders/${uuid}/statuses`,
	getOrder: (uuid) => `${baseUrl}/orders/${uuid}`,
	create_oto_order: `${baseUrl}/orders/oto/store`,
	initiate_refund: (uuid) => `${baseUrl}/myfatoorah/initiate-refund/${uuid}`,
	createShipmentOnOto: (uuid) => `${baseUrl}/orders/oto/shipment/${uuid}`,
	checkStatusForRefund: (uuid) => `${baseUrl}/myfatoorah/check-refund/${uuid}`,
	scheduleOrder: `${baseUrl}/orders/schedule`,
}

export const invoice: any = {
	endPoint: `${baseUrl}/invoices`,
	all: `${baseUrl}/invoices`,
	monthlyInvoice: `${baseUrl}/invoices/monthly-invoices`,
	downloadMonthlyInvoice : `${webRoute}/download/monthly-invoice`,
	drafts: `${baseUrl}/invoices?is_draft=1`,
	list: `${baseUrl}/invoices/list`,
	stats: `${baseUrl}/invoices/stats`,
	received_payments: `${baseUrl}/invoice-payments`,
	action: `${baseUrl}/invoices/action`,
	common: `${baseUrl}/invoices/common-data`,
	quick_payments: `${baseUrl}/invoices/quick-payments`,
	refund_payment: `${baseUrl}/invoices/refund-payment`,
	refundOnlinePayment: (uuid) => `${baseUrl}/invoices/${uuid}/refund-online-payment`,
	reCallInvoiceInfo: (uuid) => `${baseUrl}/invoices/recall-info/${uuid}`,
	products_services_list: `${baseUrl}/invoices/products-services/list`,
	deletePayment: (uuid) => `${baseUrl}/invoice-payments/${uuid}`,
	resendPayment: (uuid) => `${baseUrl}/invoice-payments/${uuid}/resend`,
	acceptPayment: (uuid) => `${baseUrl}/invoice-payments/${uuid}/accept`,
	rejectPayment: (uuid) => `${baseUrl}/invoice-payments/${uuid}/reject`,
	qr_code_base64: `${baseUrl}/invoices/qr_code_base64`,
}

export const settlements: any = {
	all: `${baseUrl}/settlements`,
}

export const wallet: any = {
	endpoint: `${environment.baseUrl}/api/wallet/checkout`,
}

export const client: any = {
	endPoint: `${baseUrl}/clients`,
	all: `${baseUrl}/clients`,
	list: `${baseUrl}/clients/list`,
	updateName: (id) => `${baseUrl}/clients/${id}/update-name`,
	invoices: (id) => `${baseUrl}/clients/${id}/invoices`,
	projects: (id) => `${baseUrl}/clients/${id}/invoices`,
	importFile: `${baseUrl}/clients/import/store`,
	download:`${webRoute}/clients/download`,
	download_pdf:`${webRoute}/clients/download_pdf`,
}

export const expense: any = {
	endPoint: `${baseUrl}/expenses`,
	all: `${baseUrl}/expenses`,
	expenses: `${baseUrl}/expenses?expense_type=project`,
	other_expenses: `${baseUrl}/expenses?expense_type=other`,
	common: `${baseUrl}/expenses/common-data`,
	refundExpense: (uuid) => `${baseUrl}/expenses/refund/${uuid}`,
}

export const proposal: any = {
	endPoint: `${baseUrl}/proposals`,
	all: `${baseUrl}/proposals`,
	drafts: `${baseUrl}/proposals?is_draft=1`,
	action: `${baseUrl}/proposals/action`,
	common: `${baseUrl}/proposals/common-data`
}

export const quotation: any = {
	endPoint: `${baseUrl}/quotations`,
	all: `${baseUrl}/quotations`,
	drafts: `${baseUrl}/quotations?is_draft=1`,
	action: `${baseUrl}/quotations/action`,
	common: `${baseUrl}/quotations/common-data`,
	products_services_list: `${baseUrl}/invoices/products-services/list`,
	reject_reason: `${baseUrl}/quotations/reject`
}

export const country: any = {
	endPoint: `${baseUrl}/countries`,
	regions: `${baseUrl}/regions`,
	cities: `${baseUrl}/cities`,
	districts: `${baseUrl}/districts`,
	delivery_cost: `${baseUrl}/delivery-cost`,
	saudi_banks: `${baseUrl}/saudi-banks`,
	banks: `${baseUrl}/banks`,
	myfatoorah_banks: `${baseUrl}/myfatoorah/banks`,
	signup: `${apiUrl}/v2/countries`,
}

export const dashboard: any = {
	expenses: `${baseUrl}/dashboard/expenses`,
	summary: `${baseUrl}/dashboard/expenses-summary`,
	invoices: `${baseUrl}/dashboard/invoices`,
	profit: `${baseUrl}/dashboard/profit-summary`,
	pendingSteps: `${baseUrl}/dashboard/pending-steps`,
	dashboardBlockData: `${baseUrl}/dashboard/dashboard-block`,
	topCustomers: `${baseUrl}/dashboard/top-customers`,
	topProducts: `${baseUrl}/dashboard/top-products`,
	recentProducts: `${baseUrl}/dashboard/recent-products`,
	currentOrders: `${baseUrl}/dashboard/current-orders`,
	historyOrders: `${baseUrl}/dashboard/history-orders`,
	pendingInvoice: `${baseUrl}/dashboard/pending-invoice`,
	download_excel: `${environment.baseUrl}/dashboard/download-excel`,
	downloadPaymentExcel:`${environment.baseUrl}/dashboard/download-payment-excel`,
	paymentHistory:	`${baseUrl}/dashboard/payment-history`,
	
	download_pdf: `${environment.baseUrl}/download/invoice-pdf`,
	downloadPaymentPDF:`${environment.baseUrl}/download/payment-pdf`,

	skipCard: `${baseUrl}/dashboard/skip-card`,
	// skipCard:`${baseUrl}/dashboard/skip-card`,
}

export const user: any = {
	me: `${baseUrl}/me`,
	basicInfo: `${baseUrl}/basic-info`,
	updateAccountInfo: `${baseUrl}/account-setting`,
	updateBusinessInfo: `${baseUrl}/general-info`,
	updateMerchantInfo: `${baseUrl}/merchant-info`,
	verifyHalaBusiness: `${baseUrl}/verify-hala-business`,
	updatePlan: `${baseUrl}/`,
	financialGoals: `${baseUrl}/financial-goals`,
	financialSummary: `${baseUrl}/financial-summary`,
	financialScore: `${baseUrl}/financial-goals/score`,
	terms: `${baseUrl}/terms`,
	setting: `${baseUrl}/setting`,
	removeHalaNumber: `${baseUrl}/remove-hala-number`,
	permissions: `${baseUrl}/permissions`,
	notifications: `${baseUrl}/notifications`,
	uploadLogo: `${baseUrl}/update-logo`,
	removeLogo: `${baseUrl}/remove-logo`,
	readNotification: (id) => `${baseUrl}/notifications/${id}/read`,
	terminateUser: `${baseUrl}/user`,
	merchants: `${baseUrl}/merchants`,
	addCity: `${baseUrl}/add-city`,
	addStoreType: `${baseUrl}/add-store-type`,
	addLog: `${baseUrl}/add-log`,
	updateStatus: `${baseUrl}/merchants/update-status`,
	moyasar: `${baseUrl}/moyasar`,
	fetchOtoClientInfo: (id) => `${baseUrl}/oto/credit/${id}`,
	addOtoCreditAmount: (amount) => `${baseUrl}/oto/add-credit/${amount}`,
	all: `${baseUrl}/users`,
	getAll: `${baseUrl}/all-users`,
	getTeemUser: (id) => `${baseUrl}/users/${id}`,
	createTeemUser: `${baseUrl}/sub-users`,
	updateTeemUser: (uuid) => `${baseUrl}/users/${uuid}`,
	action: `${baseUrl}/user-action`,
	tamara: `${baseUrl}/tamara`,
	updateTapConsent: `${baseUrl}/update-tap-consent`,
	profitLossData: `${baseUrl}/dashboard/profit-loss-report`,
}

export const taxes: any = {
	endPoint: `${baseUrl}/taxes`,
	output_taxes: `${baseUrl}/taxes/output`,
	input_taxes: `${baseUrl}/taxes/input`,
	common: `${baseUrl}/taxes/common-data`
}


export const billing: any = {
	subscriptionHistory: `${baseUrl}/billing/subscription-history`,
	billingHistory: `${baseUrl}/billing/billing-history`,
	addCard: `${baseUrl}/add-card`,
	offAutoRenew: `${baseUrl}/billing/auto-renew`,
	deleteCancelRequest: (uuid) => `${baseUrl}/billing/auto-renew/${uuid}`,
	invoiceSubscriptionHistory: `${baseUrl}/billing/invoice/subscription-history`,
	invoiceTransactionHistory: `${baseUrl}/billing/invoice/billing-history`,
	deleteInvoiceCancelRequest: (uuid) => `${baseUrl}/billing/invoice/auto-renew/${uuid}`,
	offInvoiceAutoRenew: `${baseUrl}/billing/invoice/auto-renew`,
	billingSubscriptionTransaction: `${baseUrl}/billing/invoice/subscription-transaction`,
	billingInvoiceTransactionHistory: `${baseUrl}/billing/invoice/invoice-transaction`,
}

export const services: any = {
	endPoint: `${baseUrl}/services`,
	all: `${baseUrl}/services`,
	action: `${baseUrl}/services/action`,
	common: `${baseUrl}/services/common-data`,
	stats: `${baseUrl}/services/stats`,
	serviceCategories: `${baseUrl}/categories/?type=service`,
	importFile: `${baseUrl}/services/import-data`,
}

export const store: any = {
	// endPoint: `${baseUrl}/stores`,
	updateMyStore: `${baseUrl}/stores/my-store`,
	getMyStore: `${baseUrl}/stores/my-store`,
	productInformation: `${baseUrl}/stores/product-information`,
	createBranch: `${baseUrl}/stores/create-branch`,
	serviceInformation: `${baseUrl}/stores/service-information`,
	categories: `${baseUrl}/stores/my-store/categories`,
	productCategories: `${baseUrl}/stores/my-store/categories?type=product`,
	serviceCategories: `${baseUrl}/stores/my-store/categories?type=service`,
	uploadLogo: `${baseUrl}/stores/update-logo`,
	removeLogo: (type) => `${baseUrl}/stores/remove-logo/${type}`,
	foodicsInfo: `${baseUrl}/stores/foodics-info`,
	updateFoodicsProducts: `${baseUrl}/stores/update-foodics-info`,
	disconnectFoodics: `${baseUrl}/stores/disconnect-foodics`,
	checkSlug: `${baseUrl}/stores/check-slug`,
	checkBranchSlug: `${baseUrl}/stores/check-branch-slug`,
	getAnalytics:`${baseUrl}/stores/analytics`,
	setBranch:`${baseUrl}/stores/set-branch`,
	branchesInfo:`${baseUrl}/stores/branches-information`,
	editBranch:`${baseUrl}/stores/edit-branch`,
	updateBranchStatus:`${baseUrl}/stores/update-branch-status`,
	deleteBranch: (id) =>`${baseUrl}/stores/delete-branch/${id}`,
	branchTemplateInformation: `${baseUrl}/stores/template-information`,
	templateInformation: `${baseUrl}/stores/template-information`,
	updateFoodicsBranch:`${baseUrl}/foodics/branches`,
	setReceivingBranch:`${baseUrl}/foodics/set-branch`
}

export const category: any = {
	endPoint: `${baseUrl}/categories`,
	productCategoriesList: `${baseUrl}/categories?type=product`,
	serviceCategoriesList: `${baseUrl}/categories?type=service`,
	storeFrontCategoriesApi: `${baseUrl}/categories/storefront`,
}

export const products: any = {
	endPoint: `${baseUrl}/products`,
	all: `${baseUrl}/products`,
	action: `${baseUrl}/products/action`,
	common: `${baseUrl}/products/common-data`,
	stats: `${baseUrl}/products/stats`,
	productCategories: `${baseUrl}/categories/?type=product`,
	list: `${baseUrl}/products/list`,
	importFile: `${baseUrl}/products/import-data`,
	allProducts: `${baseUrl}/products/all-products`,
	updateCreateCategory: `${baseUrl}/categories/update`,
	reorderCategory: `${baseUrl}/categories/reorder`,
	reorderProduct: `${baseUrl}/products/reorder`,
	bulkUpdate:`${baseUrl}/products/bulk-update`
}

export const coupons: any = {
	endPoint: `${baseUrl}/coupons`,
	coupons: `${baseUrl}/coupons`
}

export const applepay = {
	verifyMerchant:`${baseUrl}/apple-pay/validate-merchant`,
  	calculate_amount:`${baseUrl}/apple-pay/calculate-final-amount`,
  	authorizePayment: (uuid) => `${baseUrl}/apple-pay/authorize/${uuid}`,
}

export const auth = {
	verify: `${apiUrl}/v2/otp-verify`,
	send: `${apiUrl}/v2/otp-send`,
	resend: `${apiUrl}/v2/resend-otp`,
	register: `${apiUrl}/v1/register`,
	login: `${apiUrl}/v2/login`,
	// login: `https://test.teem-app.com/v2/login`,
	verifyLogin: `${apiUrl}/v2/verify-login`,
	checkEmail: `${apiUrl}/v1/user/check-email`,
	checkPhone: `${apiUrl}/v1/user/check-phone`,

	sendForgotOtp: `${apiUrl}/v2/send-forgot-otp`,
	verifyForgot: `${apiUrl}/v2/verify-forgot`,
	setPassword: `${apiUrl}/v2/set-password`,
}

export const wallets: any = {
	endPoint: `${baseUrl}/wallets`,
	balance: `${baseUrl}/wallets/balance`,
	transactions: `${baseUrl}/wallets/transactions`,
	topup: `${baseUrl}/wallets/topup`,
	withdraw: `${baseUrl}/wallets/withdraw`,
	withdrawAmounts: `${baseUrl}/wallets/withdraw-amounts`,
	updateAutoRenew: `${baseUrl}/wallets/update-auto-renew`,
}

export const zatca: any = {
	endPoint: `${baseUrl}/zatca`,
	getCertificate: `${baseUrl}/zatca/certificate`,
	generateCertificate: `${baseUrl}/zatca/generate-certificate`,
	requestingComplianceCertificate: `${baseUrl}/zatca/requesting-compliance-certificate`,
	generatepProductionCertificate: `${baseUrl}/zatca/generate-production-certificate`,
	updateStatus: `${baseUrl}/zatca/update-status`,
}

export const customer: any = {
	getInfo: `${baseUrl}/customer/info`,
	login:`${baseUrl}/customer/login`,
	signup:`${baseUrl}/customer/register`,
	update:`${baseUrl}/customer/update`,
	addAddress:`${baseUrl}/customer/add-address`,
	updatePassword:`${baseUrl}/customer/password-update`,
	logout:`${baseUrl}/customer/logout`,
	orders:`${baseUrl}/customer/orders`,
	endPoint: `${baseUrl}/customer/countries`,
	regions: `${baseUrl}/customer/regions`,
	cities: `${baseUrl}/customer/cities`,
	districts: `${baseUrl}/customer/districts`,
	deleteAddress:`${baseUrl}/customer/delete-address`,
	verifyLogin:`${baseUrl}/customer/verify-login`,
	resend : `${baseUrl}/customer/resend-otp`,
	send: `${baseUrl}/customer/otp-send`,
	verify: `${baseUrl}/customer/otp-verify`,
	checkEmail: `${baseUrl}/customer/check-email`,
	checkPhone: `${baseUrl}/customer/check-phone`,
	sendForgotOtp: `${baseUrl}/customer/send-forgot-otp`,
	verifyForgot: `${baseUrl}/customer/verify-forgot`,
	setPassword: `${baseUrl}/customer/set-password`,
	reOrderRoute: (uuid) => `${environment.baseUrl}/re-order/${uuid}`
}

export const profitLoss: any = {
	endPoint: `${baseUrl}/profit-loss-statement`,
	download_pdf: `${environment.baseUrl}/download/profit-loss/pdf`,
	download_excel: `${environment.baseUrl}/download/profit-loss/excel`,
}